import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { Mailing } from '../models/Mailing';
import { ProcessRecall } from '../models/ProcessRecall';

@Injectable({ providedIn: 'root' })

export class MailingService {
  private _ENDPOINT: string = '';
  private _PROCESSRECALLENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/mailings';
    this._PROCESSRECALLENDPOINT = baseUrl + 'api/processrecall';
  }
 
  getAll(filter: string): Observable<Array<Mailing>> {
     return this.http.get<Array<Mailing>>(this._ENDPOINT + '?dateFilter=' + filter );
  }


  getMostRecent(): Observable<Array<Mailing>> {
    let filterValue = new Date();
    filterValue.setMonth(filterValue.getMonth() - 12);
    return this.http.get<Array<Mailing>>(this._ENDPOINT + '?dateFilter=' + filterValue.toDateString() + '&total=5');
  }
   
  getById(id: any): Observable<Mailing> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<Mailing>(url);
  }

  /** POST: add a new campaign to the server */
  add(campaign: Mailing): Observable<Mailing> {
    return this.http.post<Mailing>(this._ENDPOINT, campaign, this.httpOptions).pipe(
      tap((newMailing: Mailing) => this.log('added campaign w/ id=${newMailing.id}')),
      catchError(this.handleError<Mailing>('add'))
    );
  }

  /** DELETE: delete the campaign from the server */
  delete(id: number): Observable<Mailing> { 
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<Mailing>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted campaign id=${id}')),
      catchError(this.handleError<Mailing>('delete'))
    );
  }

  /** PUT: update the campaign on the server */
  update(id: number, campaign: Mailing): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id , campaign , this.httpOptions).pipe(
      tap(_ => this.log('updated campaign id=${campaign.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  getProcessRecall(id: number): Observable<Array<ProcessRecall>>{
    return this.http.get<Array<ProcessRecall>>(this._PROCESSRECALLENDPOINT + '/?id=' + id);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a MailingService message with the MessageService */
  private log(message: string) {
    this.messageService.add('MailingService: ${message}');
  }
}
